import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licences: '<',
        form: '=',
        userId: '<',
        periods: '='
    },
    template: `
            <form-row error="vm.form.errors.licenceId">
              <label class="label">{{ 'licence.Licence' | translate }} *</label>
              <div class="items">
                <select class="form-control"
                        ng-disabled="vm.form.model.id"
                        ng-model="vm.form.model.licenceId"
                        ng-options="licence.id as licence.name for licence in vm.licences">
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
            <form-row error="vm.form.errors.licencePeriodId">
              <label class="label">{{ 'licence.Licence period' | translate }} *</label>
              <div class="items">
                <select class="form-control"
                        ng-model="vm.form.model.licencePeriodId"
                        ng-disabled="!vm.periods || vm.form.model.id"
                        ng-options="period.id as vm.LicenceService.licencePeriodTranslation(period)
                                    for period in vm.periods">
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
    `
})
export default class {
    constructor ($scope, LicenceService, LicencePeriodResource) {
        this.LicencePeriodResource = LicencePeriodResource;
        this.LicenceService = LicenceService;

        $scope.$watch('vm.form.model.licenceId', (licenceId) => {
            if (!licenceId) {
                return;
            }
            this.LicencePeriodResource.query({
                licenceId,
                userId: this.userId,
                isValid: true,
                isPastPeriodAllowed: this.form.model.isPastPeriodAllowed
            }).$promise.then(periods => {
                this.periods = periods;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/licencePoints/singleFormRows/index.js